import { useEffect } from 'react';
import _isEmpty from 'lodash/isEmpty';
import { useLifeCycleEventBus } from '@thd-olt-functional/utils';

export const useQuickViewClickSectionEvent = (trackQuickViewSectionViewedEvent) => {
  const quickViewClickSection = useLifeCycleEventBus('quick-view.click-section');

  useEffect(() => {
    if (!_isEmpty(quickViewClickSection)) {
      const { title } = quickViewClickSection;
      trackQuickViewSectionViewedEvent(title);
    }
  }, [quickViewClickSection]);
};
